export default __webpack_public_path__ + "static/Ecozohm-e82d63a2cc522af12ff60bb84c93628c.jpg";